import api from '../lib/api';
import { type LoginCredentials, type ApiResponse, type User } from '../types';

export const authService = {
  login: (credentials: LoginCredentials) => {
    return api.post('/auth/login', credentials);
  },

  /*
   * `register` removed. CABOS has no sign-up — accounts are created by an administrator on
   * /users/create (POST /api/admin/users), which checks who is asking, limits the assignable roles,
   * scopes the organization and can email the credentials.
   *
   * This method had no caller, and the endpoint behind it accepted `role: 'admin'` without any
   * authentication, so it was an unauthenticated route to a full admin account. The backend route is
   * gone (see the block comment in cabos_backend/src/routes/auth.ts); this is removed too so nobody
   * wires a form to it and reopens the hole from the client side.
   */

  logout: (): Promise<ApiResponse> => {
    return api.post('/auth/logout');
  },

  getCurrentUser: (): Promise<ApiResponse<User>> => {
    return api.get('/auth/me');
  },

  // Update the current user's own contact details (self-service).
  updateMe: (data: {
    first_name?: string;
    last_name?: string;
    phone?: string;
    mobile?: string;
    job_title?: string;
  }): Promise<ApiResponse<{ user: User }>> => {
    return api.patch('/auth/me', data);
  },

  forgotPassword: (email: string): Promise<ApiResponse> => {
    return api.post('/auth/forgot-password', { email });
  },

  resetPassword: (token: string, password: string, confirmPassword: string): Promise<ApiResponse> => {
    return api.post('/auth/reset-password', { token, password, confirmPassword });
  },

  changePassword: (data: {
    current_password: string;
    new_password: string;
  }): Promise<ApiResponse> => {
    return api.post('/auth/change-password', data);
  },

  startImpersonation: (targetUserId: number) =>
    api.post(`/auth/impersonate/${targetUserId}`),

  endImpersonation: () =>
    api.post('/auth/impersonate/end'),
}; 